import { setAsFavoriteStore, setStoreCookie } from './header-store-locator';
import { ellipsify, logout } from '@/customer/customer-utils';
import { init as initDashboard } from '@/customer/account/account-dashboard';

export function init () {
  const customerName = cube.$id('hdr-customers-identity');
  if (customerName)
    ellipsify(customerName);

  const headerLogout = cube.$('#header .logout-link');
  if (headerLogout)
    headerLogout.on('click', logout);

  const checkbox = cube.$id('header-favorite-store-checkbox');
  if (checkbox)
    checkbox.addEventListener('change', (e) => {
      setAsFavoriteStore(
        e.target.value,
        reloadCartridges
      );
    });

  //Set store information in a cookie for NFS bevel mode
  setStoreCookie();
}

//TODO: Move AccountUtils in this file and reinit
/**
 * Reload every cartridges with store information
 *
 */
function reloadCartridges () {
  /* eslint-disable no-underscore-dangle */
  const cartridges = {
    'header-help': window.AccountUtils._reloadHeaderHelpCenterSuccessError,
    'header-store': init,
    'header-my-account': window.AccountUtils._reloadHeaderMyAccountSuccessError,
    'dashboardContent': () => {
      initDashboard(false);
      (window.cube.config.anly_useLegacy === 'Y' ? CUBE.Analytics : CUBE.Anly).perso.lvp.init();
    },
  };
  /* eslint-enable */

  Object.keys(cartridges).forEach(cartridge => {
    if (cube.$id(cartridge))
      cube
        .cartridge(cartridge)
        .after(cartridges[cartridge])
        .reload();
  });
}



// WEBPACK FOOTER //
// ./src/commons/header/header.js